import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { BiPcauioService } from '../bi-pcauio.service';
import { ConversaoLibraConverte } from './../../../../shared/conversao-libra/conversao-libra-converte';
import { Filtros } from './../../../../shared/crud/Filtro/Filtros';
import { ListaBase } from './../../../../shared/crud/ListaBase';
import { ExportExcelService } from './../../../../shared/excel-service/export-excel.service';
import { FiltroDataComponent } from './../../../../shared/filtro-data/filtro-data.component';
import { FormatarData } from './../../../../shared/formatarData';
import { PrintPdfService } from './../../../../shared/print-pdf/print-pdf.service';
import { Parametro } from './../../../../shared/service-base/parametro';

@Component({
  selector: 'app-bi-pcauio-lista',
  templateUrl: './bi-pcauio-lista.component.html',
  styleUrls: ['./bi-pcauio-lista.component.css']
})
export class BiPcauioListaComponent extends ListaBase implements OnInit {
  codigo_dealer: any;
  nome_dealer: any;
  ano_anterior_motos = 0;
  ano_atual_motos = 0;
  percentual_motos = 0;
  ano_anterior_roupas = 0;
  ano_atual_roupas = 0;
  percentual_roupas = 0;
  ano_anterior_pca = 0;
  ano_atual_pca = 0;
  percentual_pca = 0;
  ano_anterior_acessorios = 0;
  ano_atual_acessorios = 0;
  percentual_acessorios = 0;
  ano_anterior_pcauio = 0;
  ano_atual_pcauio = 0;
  crescimento_pcauio = 0;
  percentual_pcauio = 0;
  venda_oportunidade = 0;
  cols: any[];
  colsTitle: any[];
  _selectedColumns: any[];
  _selectedColumnsTitle: any[];
  dataInicialFormata
  dataFinalFormata
  Sysdate: FiltroDataComponent = new FiltroDataComponent;
  max: any;
  min: any;
  carregando = false;
  InicialData; // Set the first Day of month
  FinalData; // set the last day of query
  parametrosFiltro: any;
  tituloTabela: string;
  textoData: string;
  pcauioDados: any;
  subscription;
  filtroconsolidado = false;
  filtropecas = true;
  filtroroupas = true;
  filtroacessorios = true;
  tipo: any;
  titulo = 'PCA-CONSOLIDADO';

  dadosTranslate = {
    "Brasil": "businessIntelligence.PCAUIO.brasil"
  }

  constructor(service: BiPcauioService,
    toastr: ToastrService,
    router: Router,
    private exportExcel: ExportExcelService,
    private printPdf: PrintPdfService,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private conversaoLibraConverte: ConversaoLibraConverte) {
    super(service, toastr, router);
    const max = new Date();
    const min = new Date();

    this.max = { 'year': max.getFullYear(), 'month': max.getMonth() + 1, 'day': max.getUTCDate() };
    this.min = { 'year': min.getFullYear() - 1, 'month': min.getMonth() + 1, 'day': min.getUTCDate() + 1 };
    this.route.queryParams.subscribe(params => {
      this.parametrosFiltro = params;
      this.setaValorData(params['data_inicial'], params['data_final']);
      this.carregarFiltrosParametros();
    });
    this.nomeModulo = 'bi-pcauio';
  }

  ngOnInit() {
    this.tipo = [1, 2, 3];
    this.buscar()
    //conversaolibra
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.buscar();
      });
    //fimConversaolibra
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setaValorData(dataInicial: Date, dataFinal: Date) {
    const dt = new Date();
    if (dataInicial === undefined || dataInicial.toString() === '') {
      const dt = new Date();
      const dataInicial = { 'year': dt.getFullYear(), 'month': dt.getMonth() + 1, 'day': 1 };
      this.dataInicialFormata = new FormatarData(dataInicial.year, dataInicial.month, dataInicial.day, 0, 0, 0).getDataString();
      this.InicialData = dataInicial;
    } else {
      const now = new Date(dataInicial);
      this.InicialData = { 'year': now.getUTCFullYear(), 'month': now.getMonth() + 1, 'day': now.getDate() };
    }

    if (dataFinal === undefined || dataFinal.toString() === '') {
      const dt = new Date();
      const dataFinal = { 'year': dt.getFullYear(), 'month': dt.getMonth() + 1, 'day': dt.getDate() };
      this.dataFinalFormata = new FormatarData(dataFinal.year, dataFinal.month, dataFinal.day, 0, 0, 0).getDataString();
      this.FinalData = dataFinal;
    } else {
      const now = new Date(dataFinal);
      this.FinalData = { 'year': now.getUTCFullYear(), 'month': now.getMonth() + 1, 'day': now.getUTCDate() };
    }

    this.filtros = { data_inicial: this.InicialData, data_final: this.FinalData, tipo: this.tipo };
  }

  setaValorData2() {
    this.filtros = {
      data_inicial: this.InicialData.year + "-" + this.InicialData.month + "-" + this.InicialData.day + "T00:00:00-04:00",
      data_final: this.FinalData.year + "-" + this.FinalData.month + "-" + this.FinalData.day + "T00:00:00-04:00",
      tipo: this.tipo
    };
  }

  get dataInicial(): any { return this.tratarGetDropDown(this.filtros.data_inicial); }
  set dataInicial(data) { this.filtros.data_inicial = this.getDataString(data); }

  get dataFinal(): any { return this.tratarGetDropDown(this.filtros.data_final); }
  set dataFinal(data) { this.filtros.data_final = this.getDataString(data); }

  tratarGetDropDown(selecionado: any): string {
    if (selecionado === null || selecionado === undefined) {
      return '';
    }
    return selecionado;
  }

  getDataString(data): any {
    return new FormatarData(
      data.year,
      data.month,
      data.day,
      0,
      0,
      0
    ).getDataString();
  }

  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {

          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.data_inicial
      || this.filtros.data_final;
  }

  carregar() {
    const objFiltro = new Filtros();

    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        objFiltro.filtros.push(new Parametro(chave, this.filtros[chave]));
      }
    }
  }

  exportarExcel() {
    this.exportExcel.nomeModulo = this.nomeModulo;
    this.exportExcel.ExportTOExcel();
  }

  imprimePdf() {
    if (this.translate.currentLang == 'br') {
      this.tituloTabela = 'PCAUIO - Ticket Médio de PCA';
      this.textoData = 'Data Ref.:';
    } else if (this.translate.currentLang == 'gb') {
      this.tituloTabela = 'PCAUIO - Average PCA Ticket';
      this.textoData = 'Ref. Date:';
    }

    this.printPdf.tituloTabela = this.tituloTabela;
    this.printPdf.nomeModulo = this.nomeModulo;
    this.printPdf.textoData = this.textoData;
    this.printPdf.exportPDFA4(this.filtros.data_inicial);
    this.printPdf.exportPDFA4(this.filtros.data_final);
  }

  getTranslate(value) {
    return this.dadosTranslate[value];
  }

  buscar() {
    this.ano_anterior_motos = 0;
    this.ano_atual_motos = 0;
    this.percentual_motos = 0;
    this.ano_anterior_pca = 0;
    this.ano_atual_pca = 0;
    this.percentual_pca = 0;
    this.ano_anterior_pcauio = 0;
    this.ano_atual_pcauio = 0;
    this.crescimento_pcauio = 0;
    this.percentual_pcauio = 0;
    this.venda_oportunidade = 0;
    let objFiltro: Filtros = new Filtros();
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }

    this.carregando = true;

    this.service.buscar(objFiltro)
      .then(res => {
        res.dados.forEach(dados => {
          dados.ano_atual_pecas = this.conversaoLibraConverte.conversaoLibra(dados.ano_atual_roupas, null, null);
          dados.ano_anterior_pecas = this.conversaoLibraConverte.conversaoLibra(dados.ano_anterior_roupas, null, null);
          dados.ano_atual_pcauio = this.conversaoLibraConverte.conversaoLibra(dados.ano_atual_pcauio, null, null);
          dados.ano_anterior_pcauio = this.conversaoLibraConverte.conversaoLibra(dados.ano_anterior_pcauio, null, null);
          dados.crescimento_pcauio = this.conversaoLibraConverte.conversaoLibra(dados.crescimento_pcauio, null, null);
          dados.venda_oportunidade = this.conversaoLibraConverte.conversaoLibra(Math.abs(dados.venda_oportunidade), null, null);
        });

        this.pcauioDados = res.dados;
        this.calculandoTotal(res);
        this.orderBypcauio();

        this.carregando = false;
      });

  }

  calculandoTotal(res) {
    this.nome_dealer = 'Brasil'
    this.venda_oportunidade = res.totalVendaOportunidade;
    this.crescimento_pcauio = res.totalCrescimentoPcauio;
    this.ano_anterior_motos = res.totalAnoAnteriorMotos;
    this.ano_anterior_pca = res.totalAnoAnteriorPca;
    this.ano_anterior_pcauio = res.totalAnoAnteriorPcauio;
    this.ano_atual_motos = res.totalAnoAtualMotos;
    this.ano_atual_pca = res.totalAnoAtualPca;
    this.ano_atual_pcauio = res.total_ano_atual_pcauio;
    this.percentual_pca = res.totalPercentualPca;
    this.percentual_pcauio = res.totalPercentualPcauio;
    this.percentual_motos = res.totalPercentualMotos;

  }

  consolidado() {
    this.filtroconsolidado = false;
    this.filtropecas = true;
    this.filtroroupas = true;
    this.filtroacessorios = true;
    this.tipo = [1, 2, 3];
    this.setaValorData2();
    this.carregando = true;
    this.titulo = 'PCA-CONSOLIDADO';
    this.buscar();
    this.carregando = false;
  }

  pecas() {
    this.filtroconsolidado = true;
    this.filtropecas = false;
    this.filtroroupas = true;
    this.filtroacessorios = true;
    this.tipo = 3;
    this.setaValorData2()
    this.carregando = true
    this.titulo = 'PEÇAS';
    this.buscar();
    this.carregando = false;
  }

  roupas() {
    this.filtroconsolidado = true;
    this.filtropecas = true;
    this.filtroroupas = false;
    this.filtroacessorios = true;
    this.tipo = 2;
    this.setaValorData2();
    this.carregando = true;
    this.titulo = 'ROUPAS';
    this.buscar();
    this.carregando = false;

  }

  acessorios() {
    this.filtroconsolidado = true;
    this.filtropecas = true;
    this.filtroroupas = true;
    this.filtroacessorios = false;
    this.tipo = 1;
    this.setaValorData2();
    this.carregando = true;
    this.titulo = 'ACESSÓRIOS';
    this.buscar();
    this.carregando = false;
  }

  private orderBypcauio() {
    this.pcauioDados.sort((a, b) => {
      let ano_atual_pcauio_a = a.ano_atual_pcauio;
      let ano_atual_pcauio_b = b.ano_atual_pcauio;

      if (ano_atual_pcauio_a > ano_atual_pcauio_b) return -1;
      if (ano_atual_pcauio_a < ano_atual_pcauio_b) return 1;

      return 0;
    });
  }

  getColor(index: any): string {
    let maior: string = "#9cc09c";
    let menor: string = "#c09c9c";

    if (index.ano_atual_pcauio >= this.ano_atual_pcauio) {
      return maior;
    } else {
      return menor;
    }
  }

}
